import { Button } from "../Button/Button";
import { ContentLayout } from "../ContentLayout/ContentLayout";
import { InfoBox } from "../InfoBox/InfoBox";
import styles from "./RecoveryPage.module.scss";
import { i18n } from "@lingui/core";
import Cookies from "universal-cookie";

export const RecoveryPage = () => {
  const cookies = new Cookies();
  const language = cookies.get("classpad_language");
  console.log("language", language);
  if (language === "fr") {
    return (
      <ContentLayout>
        <div className={styles.recovery_fr}>
          <h1>{i18n._({ id: "recover.header" })}</h1>
          <div className={styles.infoBox}>
            <InfoBox
              message={i18n._({ id: "recover.inform-text" })}
              type={"info"}
            ></InfoBox>
          </div>

          <div className={styles.infoBox} style={{ marginBottom: 0 }}>
            <InfoBox
              message={i18n._({ id: "recover.inform.forgot.password" })}
              type={"info"}
            ></InfoBox>
          </div>

          <Button
            label={i18n._({ id: "recover.btn.recovery" })}
            onClick={() => {
              window.location.href = "/auth/recovery";
            }}
            className={styles.recovery_fr__btn}
          ></Button>

          <div className={styles.infoBox}>
            <InfoBox
              message={i18n._({
                id: "recover.inform.not.received.recover.link",
              })}
              type={"info"}
            ></InfoBox>
          </div>
          <Button
            label={i18n._({ id: "recover.btn.resend-verification-link" })}
            onClick={() => {
              window.location.href = "/auth/verification";
            }}
            className={styles.recovery_fr__btn}
          ></Button>
        </div>
      </ContentLayout>
    );
  } else {
    return (
      <ContentLayout>
        <div className={styles.recovery}>
          <h1>{i18n._({ id: "recover.header" })}</h1>
          <div className={styles.infoBox}>
            <InfoBox
              message={i18n._({ id: "recover.inform-text" })}
              type={"info"}
            ></InfoBox>
          </div>

          <Button
            label={i18n._({ id: "recover.btn.recovery" })}
            onClick={() => {
              window.location.href = "/auth/recovery";
            }}
            className={styles.recovery__btn}
          ></Button>
          <Button
            label={i18n._({ id: "recover.btn.resend-verification-link" })}
            onClick={() => {
              window.location.href = "/auth/verification";
            }}
            className={styles.recovery__btn}
          ></Button>
        </div>
      </ContentLayout>
    );
  }
};
